import { render, staticRenderFns } from "./ZidArLogo.vue?vue&type=template&id=37419a20&scoped=true"
import script from "./ZidArLogo.vue?vue&type=script&lang=js"
export * from "./ZidArLogo.vue?vue&type=script&lang=js"
import style0 from "./ZidArLogo.vue?vue&type=style&index=0&id=37419a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37419a20",
  null
  
)

export default component.exports